import React from 'react';
import { motion } from 'framer-motion';
export function HeroBanner() {
  return <section className="relative w-full bg-cream overflow-hidden" data-id="element-231">
      <motion.div initial={{
      opacity: 0
    }} animate={{
      opacity: 1
    }} transition={{
      duration: 1,
      ease: 'easeOut'
    }} className="relative w-full h-[60vh] md:h-[75vh] lg:h-[85vh] max-h-[800px]" data-id="element-232">
        <img src="https://cdn.magicpatterns.com/uploads/iTvjMtv67WF1FZPzgN2shS/Opcion_1_para_Anuncio_1.png" alt="Mujer disfrutando el programa Menopause Reset desde su tablet en casa" className="absolute inset-0 w-full h-full object-cover object-top" data-id="element-233" />

        {/* Soft cream fade at bottom to blend into next section */}
        <div className="absolute inset-x-0 bottom-0 h-32 bg-gradient-to-b from-transparent to-cream pointer-events-none" data-id="element-234"></div>
      </motion.div>
    </section>;
}